<ng-container>

  <!-- ===========================
    label
  =========================== -->
  <label 
    [attr.for]="id"
    class="form-label"
    [ngClass]="labelClassStyle">

    @if (getTemplate('label'); as labelTpl) {
      <ng-container *ngTemplateOutlet="labelTpl.templateRef; context: { $implicit: label }" />
    }
    @else {
      {{label}}
    }
  </label>

  <!-- ===========================
    textarea Field
  =========================== -->
  <textarea
    appFormFieldStatus
    appFormInputField
    [ignoreStatus]="ignoreStatus"
    (blur)="onInputTouched()"
    (input)="onInputChange($event)"
    [id]="id"
    [rows]="rows"
    [size]="size"
    [name]="name"
    [value]="value"
    [disabled]="disabled"
    [readonly]="readonly"
    [required]="required"
    [placeholder]="placeholder"
    [attr.aria-label]="ariaLabel ?? label"
    [attr.aria-describedby]="described ?? label ?? textHelp"></textarea>

  <!-- ===========================
    feedbackType Outlet
  =========================== -->
  @if (touched && (feedbackValidMsg || invalid)) {
    <div [appFormFieldFeedback]="dynamicFeedbackUI" [feedbackProvider]="feedbackProvider">
      <ng-container 
        *ngTemplateOutlet="getTemplate('feedbackMsg')?.templateRef ?? feedbackMsgTpl; context: feedbackContext" />
    </div>
  }

  <!-- ===========================
    TextHelp Outlet
  =========================== -->
  <ng-container 
    *ngTemplateOutlet="getTemplate('textHelp')?.templateRef ?? textHelpTpl; context: { $implicit: textHelp }" />

</ng-container>

<!-- ===========================
  TextHelp Block
=========================== -->
<ng-template #textHelpTpl let-textHelp>
  @if (textHelp) {
    <div class="form-text" [ngClass]="textHelpClassStyle">{{textHelp}}</div>
  }
</ng-template>

<!-- ===========================
  TextHelp Block
=========================== -->
<ng-template #feedbackMsgTpl let-msg>
  {{msg}}
</ng-template>